import { api } from '@/services/index'
import store from '@/store'

import moment from 'moment'

function getQuery(_filter) {
    let query = ''
    if (_filter.cliCodigo)
        query += `cliCodigo=${_filter.cliCodigo}`
    if (_filter.comValID)
        query += `comValID=${_filter.comValID}`
    if (_filter.comValLogDataIni)
        query += (query == '' ? '' : '&') + `comValLogDataIni=${moment(_filter.comValLogDataIni).format('YYYY-MM-DD')}`
    if (_filter.comValLogDataFim)
        query += (query == '' ? '' : '&') + `comValLogDataFim=${moment(_filter.comValLogDataFim).format('YYYY-MM-DD')}`
    if (_filter.byReturn < 3)
        query += (query == '' ? '' : '&') + `filterReturn=${_filter.byReturn}`
    if (_filter.week)
        query += (query == '' ? '' : '&') + `week=${_filter.week}`

    return query
}

const loadComandosValidacaoLog = (_filter) => {
    store.dispatch('setComandosValidacaoLogLoadingData', true)

    let query = getQuery(_filter)

    api.get(`/emsweb/listaComandosValidacaoLog?${query}`)
        .then(_res => {
            store.dispatch('setComandosValidacaoLogData', _res.data)

            setTimeout(function () {
                store.dispatch('setComandosValidacaoLogLoadingData', false)
            }, 300)
        })
        .catch(_err => {
            store.dispatch('setComandosValidacaoLogSnackBar', {
                visible: true,
                message: `${_err.response.data.message}`
            })
        })
}

const loadComandosValidacaoLogDataDetails = (_comValID, _filter) => {
    store.dispatch('setComandosValidacaoLogLoadingDataDetails', true)

    let query = getQuery({ comValID: _comValID, ..._filter })

    api.get(`/emsweb/listaComandosValidacaoLogDetails?${query}`)
        .then(_res => {
            store.dispatch('setComandosValidacaoLogDataDetails', _res.data)

            setTimeout(function () {
                store.dispatch('setComandosValidacaoLogLoadingDataDetails', false)
            }, 200)
        })
        .catch(_err => {
            store.dispatch('setComandosValidacaoLogSnackBar', {
                visible: true,
                message: `${_err.response.data.message}`
            })
        })
}

const loadComandosValidacaoLogByReturns = (_filter) => {
    store.dispatch('setComandosValidacaoLogLoadingByReturns', true)

    let query = getQuery(_filter)

    api.get(`/emsweb/listaComandosValidacaoLogRetornos?${query}`)
        .then(_res => {
            const data = _res.data[0]
            const byReturns = [data.withError, data.nonReturn, data.withReturn]
            store.dispatch('setComandosValidacaoLogByReturns', byReturns)

            setTimeout(function () {
                store.dispatch('setComandosValidacaoLogLoadingByReturns', false)
            }, 200)
        })
        .catch(_err => {
            store.dispatch('setComandosValidacaoLogSnackBar', {
                visible: true,
                message: `${_err.response.data.message}`
            })
        })
}

const loadComandosValidacaoLogByWeeks = (_filter) => {
    store.dispatch('setComandosValidacaoLogLoadingByWeeks', true)

    let query = getQuery(_filter)

    api.get(`/emsweb/listaComandosValidacaoLogPorSemana?${query}`)
        .then(_res => {
            store.dispatch('setComandosValidacaoLogByWeeks', _res.data)

            setTimeout(function () {
                store.dispatch('setComandosValidacaoLogLoadingByWeeks', false)
            }, 200)
        })
        .catch(_err => {
            store.dispatch('setComandosValidacaoLogByWeeks', null)
            store.dispatch('setComandosValidacaoLogSnackBar', {
                visible: true,
                message: `${_err.response.data.message}`
            })
        })
}

const loadComandosValidacaoLogByVersion = (_filter) => {
    store.dispatch('setComandosValidacaoLogLoadingByVersions', true)

    let query = getQuery(_filter)

    api.get(`/emsweb/listaComandosValidacaoLogPorVersao?${query}`)
        .then(_res => {
            store.dispatch('setComandosValidacaoLogByVersions', _res.data)
            setTimeout(function () {
                store.dispatch('setComandosValidacaoLogLoadingByVersions', false)
            }, 200)
        })
        .catch(_err => {
            store.dispatch('setComandosValidacaoLogSnackBar', {
                visible: true,
                message: `${_err.response.data.message}`
            })
        })
}

export { loadComandosValidacaoLog, loadComandosValidacaoLogDataDetails, loadComandosValidacaoLogByReturns, loadComandosValidacaoLogByWeeks, loadComandosValidacaoLogByVersion }